import withNav from '@/components/hocs/withNav';
import PodcastEpisodePDP, { PodcastEpisodeVariantPDP } from '@/components/ui/PDP/PodcastEpisodePDP';
import type { PodcastEpisodeVariation as PodcastEpisodeVariationProps } from '@/@types/content';
import { useGetContentQuery } from '@/redux/api/contentDeliveryAPI';
import { skipToken } from '@reduxjs/toolkit/query';

const PodcastEpisodeVariationComponent = (content: PodcastEpisodeVariationProps) => {
  const { data: dataContent, isFetching: isFetchingContent } = useGetContentQuery(
    content ? { contentLink: String(content.parentProductGuidValue) } : skipToken
  );

  const podcastEpisode = content as PodcastEpisodeVariantPDP;

  return !isFetchingContent && <PodcastEpisodePDP content={podcastEpisode} parent={dataContent} />;
};

const PodcastEpisodeVariation = withNav(PodcastEpisodeVariationComponent);
export default PodcastEpisodeVariation;
